import { Feature } from '@turf/turf';
import * as turf from '@turf/turf';

export class TurfHelpers {
    public static nearestPointOnLine(lines: any, pt: any, options: any): Feature<turf.Point> {
        if (options === void 0) {
            options = {};
        }
        let closestPt: any = turf.helpers.point([Infinity, Infinity], {
            dist: Infinity
        });
        let length = 0.0;
        turf.meta.flattenEach(lines, (line) => {
            const coords = turf.invariant.getCoords(line);
            let minIndex = Infinity;
            for (let i = 0; i < coords.length - 1; i++) {
                //start
                const start: Feature<turf.Point, { dist: number; index: number; location: number }> = turf.helpers.point(coords[i]);
                start.properties['dist'] = turf.distance(pt, start, options);
                //stop
                const nextPoint: Feature<turf.Point, { dist: number; index: number; location: number }> = turf.helpers.point(coords[i + 1]);
                nextPoint.properties['dist'] = turf.distance(pt, nextPoint, options);
                // sectionLengthD
                const sectionLength = turf.distance(start, nextPoint, options);
                //perpendicular
                const heightDistance = Math.max(start.properties['dist'], nextPoint.properties['dist']);
                const direction = turf.bearing(start, nextPoint);
                const perpendicularPt1 = turf.destination(pt, heightDistance, direction + 90, options);
                const perpendicularPt2 = turf.destination(pt, heightDistance, direction - 90, options);
                const intersect = turf.lineIntersect(turf.helpers.lineString([
                    perpendicularPt1.geometry.coordinates,
                    perpendicularPt2.geometry.coordinates,
                ]), turf.helpers.lineString([start.geometry.coordinates, nextPoint.geometry.coordinates]));
                let intersectPt = null;
                if (intersect.features.length > 0) {
                    intersectPt = intersect.features[0];
                    intersectPt.properties['sequence'] = i + 1;
                    intersectPt.properties['dist'] = turf.distance(pt, intersectPt, options);
                    intersectPt.properties['location'] =
                        length + turf.distance(start, intersectPt, options);
                }
                if (start.properties['dist'] < closestPt.properties.dist
                    // && start.properties!['index'] < minIndex
                ) {
                    closestPt = start;
                    closestPt.properties.index = i;
                    closestPt.properties.location = length;
                }
                if (nextPoint.properties.dist < closestPt.properties.dist
                    // && nextPoint.properties!['index'] < minIndex
                ) {
                    closestPt = nextPoint;
                    closestPt.properties.index = i + 1;
                    closestPt.properties.location = length + sectionLength;
                }
                if (intersectPt
                    && intersectPt.properties['dist'] < closestPt.properties.dist
                    && intersectPt.properties['location'] < 20
                    && (intersectPt.properties['index'] < minIndex || minIndex === Infinity)
                ) {
                    closestPt = intersectPt;
                    closestPt.properties.index = i;
                    minIndex = intersectPt.properties['sequence'];
                }

                // update length
                length += sectionLength;
            }
        });
        return closestPt;
    }

    public static lineSlice(startPt: Feature<turf.Point>, stopPt: Feature<turf.Point>, line: Feature<turf.LineString>) {
        // Validation
        const coords = turf.invariant.getCoords(line);
        if (turf.invariant.getType(line) !== 'LineString') {
            throw new Error('line must be a LineString');
        }

        const startVertex = this.nearestPointOnLine(line, startPt, {});
        const stopVertex = this.nearestPointOnLine(line, stopPt, {});
        let ends;
        if (startVertex.properties['index'] <= stopVertex.properties['index']) {
            ends = [startVertex, stopVertex];
        } else {
            ends = [stopVertex, startVertex];
        }
        const clipCoords = [ends[0].geometry.coordinates];
        for (
            let i = ends[0].properties['index'] + 1;
            i < ends[1].properties['index'] + 1;
            i++
        ) {
            clipCoords.push(coords[i]);
        }
        clipCoords.push(ends[1].geometry.coordinates);
        return turf.helpers.lineString(clipCoords, line.properties);
    }
}
